import type { CSSProperties } from "react";
import { cn } from "./cn";

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}

/** Approximate geometry placeholder. Wrap a group in aria-busy, don't announce each block. */
export function Skeleton({ width = "100%", height = 16, className }: SkeletonProps) {
  const style: CSSProperties = { width, height };
  return <span className={cn("ui-skeleton", className)} style={style} aria-hidden="true" />;
}

export interface LoadingRowsProps {
  /** Announced once to assistive tech; the bars are decorative. */
  label: string;
  rows?: number;
}

/** Table/list placeholder with the same row rhythm as `.ui-table`, so content doesn't jump. */
export function LoadingRows({ label, rows = 5 }: LoadingRowsProps) {
  return (
    <div role="status" aria-busy="true" className="ui-loading-rows">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <span key={index} className="ui-loading-row" aria-hidden="true">
          <Skeleton width={28} height={28} className="is-round" />
          <Skeleton width={`${34 - ((index * 7) % 12)}%`} height={12} />
          <Skeleton width={`${18 + ((index * 5) % 10)}%`} height={12} />
        </span>
      ))}
    </div>
  );
}
